<ambita-instant-purchase class="ambita-instant-purchase ambita-modal__overlay">
  <div class="ambita-instant-purchase__modal-container">
    <p>{ i18n.instantPurchase.purchasePantebokIntro }</p>
    <p>{ i18n.instantPurchase.purchasePantebokOnCharging }</p>
    <p>{ i18n.instantPurchase.purchasePantebokOnAddingToOrderList }</p>
    <div class="ambita-instant-purchase__order-actions">
      <a class="ambita-instant-purchase__cancel-order" href="" onclick="{ closeModal }">
        { i18n.instantPurchase.cancel }
      </a>
      <button type="button" class="ambita-product-order ambita-button ambita-button--available-light ambita-clickable"
        onclick="{ addToCart }">
        { i18n.instantPurchase.charge }
        <ambita-currency infoland-currency-symbol="{ i18n.instantPurchase.currencyShortNOK }"
          infoland-currency-amount="{ opts.injectedAmount }">
        </ambita-currency>
      </button>
    </div>
    <div class="ambita-instant-purchase__one-click-agreement">
      <label><input type="checkbox" ref="oneClickAgreement"/> { i18n.instantPurchase.saveLookupPreference }</label>
    </div>
  </div>

  <script>
    import './currency.tag';
    import './instantPurchase.scss';
    import './instantPurchaseTranslations';
    import { init } from './instantPurchaseController';

    init(this);
  </script>
</ambita-instant-purchase>
